<div class="box box-info">
  <div class="box-header with-border">
    <h3 class="box-title">Add Beneficiary</h3>
  </div>
  <!-- /.box-header -->
  <!-- form start -->
  <form class="form-horizontal" role="form" [formGroup]="form" novalidate>
    <div class="box-body">
      <div class="form-group">
        <label for="inputPassword3" class="col-sm-3 control-label"
          >Benficiary name</label
          >

          <div class="col-sm-9">
            <input type="text" class="form-control" formControlName="title" />
            @if (
              form.controls['title'].hasError('required') &&
              (form.controls['title'].touched || attemptedSubmit)
              ) {
              <control-message
                message="Name is required."
              ></control-message>
            }
          </div>
        </div>
      </div>
      <!-- /.box-body -->
      <div class="box-footer">
        <div class="box-footer">
          <button
            type="button"
            (click)="submitForm()"
            class="btn btn-info pull-right"
            >
            Add Benficiary
          </button>
        </div>
      </div>
      <!-- /.box-footer -->
    </form>
  </div>
